import { render, staticRenderFns } from "./blackScreen.vue?vue&type=template&id=fa8ef4dc&scoped=true&"
import script from "./blackScreen.vue?vue&type=script&lang=js&"
export * from "./blackScreen.vue?vue&type=script&lang=js&"
import style0 from "./blackScreen.vue?vue&type=style&index=0&id=fa8ef4dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8ef4dc",
  null
  
)

export default component.exports